import React, { forwardRef } from 'react';
import propTypes from '@styled-system/prop-types';

import styled from 'styled-components';
import { space, color, layout, position, grid, border } from 'styled-system';

const BaseGrid = styled.div`
    ${color}
    ${space}
    ${layout}
    ${grid}
    ${position}
    ${border}
`;

const GridContainer = forwardRef(({ columns = [1], templateColumns, className = '', ...props }, ref) => (
    <BaseGrid
        className={className}
        display="grid"
        gridGap={['mobile', 'tablet', 'desktop']}
        gridTemplateColumns={templateColumns || columns.map((cols) => `repeat(${cols}, minmax(0, 1fr))`)}
        gridTemplateRows="1fr"
        {...props}
        ref={ref}
    />
));

GridContainer.propTypes = {
    ...propTypes.color,
    ...propTypes.space,
    ...propTypes.layout,
    ...propTypes.flexbox,
    ...propTypes.shadow,
    ...propTypes.position,
};

export default GridContainer;
